import { useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();
  return (
    <footer className="relative w-full bg-background-200 border-t border-background-300/60 text-foreground-700">
      <div className="w-full px-6 md:px-10 max-w-[1600px] mx-auto py-16 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-flashlight-fill text-lg"></i>
              </div>
              <div className="leading-tight">
                <div
                  className="text-foreground-950 tracking-widest text-xl"
                  style={{ fontFamily: "var(--font-heading)" }}
                >
                  HAYABUSA WORKS
                </div>
                <div className="text-[10px] tracking-[0.3em] text-foreground-9500">
                  ハヤブサワークス
                </div>
              </div>
            </div>
            <p className="text-sm leading-relaxed max-w-sm">
              3Dプリント技術で「飛ぶ」を極める、島根発の次世代フィッシングギアブランド。雷撃シリーズ製造・販売元。
            </p>
            <div className="flex gap-3 mt-8">
              {[
                { i: "ri-instagram-line", href: "https://www.instagram.com/hayabusaworks2024" },
                { i: "ri-youtube-line", href: "https://www.youtube.com/@HayabusaWorks2024" },
                { i: "ri-twitter-x-line", href: "https://x.com/raigekiakamaru" },
              ].map((s) => (
                <a
                  key={s.i}
                  href={s.href}
                  rel="nofollow"
                  className="w-10 h-10 flex items-center justify-center rounded-full border border-background-400/60 text-foreground-800 hover:bg-primary-500 hover:border-primary-500 hover:text-background-50 transition cursor-pointer"
                >
                  <i className={`${s.i} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="text-[10px] tracking-[0.3em] text-foreground-9500 mb-4">
              PRODUCT
            </div>
            <ul className="space-y-3 text-sm">
              <li><a href="/#raigeki-00" className="hover:text-primary-500 cursor-pointer">雷撃カゴ00</a></li>
              <li><a href="/#raigeki-01" className="hover:text-primary-500 cursor-pointer">雷撃カゴ01</a></li>
              <li><a href="/#raigeki-02" className="hover:text-primary-500 cursor-pointer">雷撃カゴ02</a></li>
              <li><a href="/#raigeki-03" className="hover:text-primary-500 cursor-pointer">雷撃カゴ03</a></li>
              <li><a href="/#short-tenbin" className="hover:text-primary-500 cursor-pointer">ショート天秤</a></li>
              <li><a href="/#long-tenbin" className="hover:text-primary-500 cursor-pointer">ロング天秤</a></li>
              <li><a href="/how-to#how-to-use" className="hover:text-primary-500 cursor-pointer">雷撃カゴと天秤の使い方</a></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="text-[10px] tracking-[0.3em] text-foreground-9500 mb-4">
              COMPANY
            </div>
            <ul className="space-y-3 text-sm">
              <li><a href="/#craftsmanship" className="hover:text-primary-500 cursor-pointer">エンジニアリング</a></li>
              <li><a href="/#technology" className="hover:text-primary-500 cursor-pointer">技術思想</a></li>
              <li><a href="/#product" className="hover:text-primary-500 cursor-pointer">商品ラインナップ</a></li>
              <li><a href="/#catches" className="hover:text-primary-500 cursor-pointer">実釣の成果</a></li>
              <li><a href="/#news" className="hover:text-primary-500 cursor-pointer">ニュース</a></li>
              <li><a href="/#contact" className="hover:text-primary-500 cursor-pointer">お問い合わせ</a></li>
              <li><a href="https://raigeki-hayabusa.stores.jp/" target="_blank" rel="nofollow" className="hover:text-primary-500 cursor-pointer">公式オンラインショップ</a></li>
              <li>
                <span className="hover:text-primary-500 cursor-default">取扱店</span>
                <ul className="mt-2 space-y-1.5 pl-3 border-l-2 border-background-300/60">
                  <li className="text-xs text-foreground-9500 py-0.5">かめや釣具 出雲店</li>
                  <li className="text-xs text-foreground-9500 py-0.5">かめや釣具 浜田店</li>
                  <li className="text-xs text-foreground-9500 py-0.5">かめや釣具 松江店</li>
                </ul>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="text-[10px] tracking-[0.3em] text-foreground-9500 mb-4">
              CONTACT
            </div>
            <div className="text-sm leading-relaxed">
              島根県松江市
            </div>
            <a href="mailto:hayabusaworks2024@gmail.com" className="text-sm mt-4 inline-block hover:text-primary-500 transition cursor-pointer">hayabusaworks2024@gmail.com</a>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-background-300/60 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="text-xs text-foreground-9500">
            © 2026 ハヤブサワークス All rights reserved.
          </div>
          <div className="flex flex-wrap gap-5 text-xs text-foreground-9500">
            <span onClick={() => { navigate('/privacy-policy'); window.scrollTo({ top: 0, behavior: 'smooth' }); }} className="hover:text-primary-500 cursor-pointer">プライバシーポリシー</span>
            <span onClick={() => { navigate('/commercial-law'); window.scrollTo({ top: 0, behavior: 'smooth' }); }} className="hover:text-primary-500 cursor-pointer">特定商取引法に基づく表記</span>
            <span onClick={() => { navigate('/terms'); window.scrollTo({ top: 0, behavior: 'smooth' }); }} className="hover:text-primary-500 cursor-pointer">利用規約</span>
          </div>
        </div>
      </div>
    </footer>
  );
}